import styled from "styled-components"
import {color, border, layout, space, typography} from "styled-system"

import Text from "./text.js"

const StyledButton = styled.button.attrs({
  backgroundColor: "primary",
  border: "none",
  borderRadius: "default",
  height: "input",
  lineHeight: "input",
  minWidth: "button",
  fontWeight: "bold",
  color: "white",
})`
  ${color} ${border} ${layout} ${space} ${typography}
  cursor: pointer;
`
const StyledButtonSecondary = styled(StyledButton).attrs({
  backgroundColor: "white",
  color: "primary",
  border: "1px solid",
  borderColor: "primary",
  px: 3,
})``
const StyledLabel = styled(Text).attrs({
  fontSize: "label",
})``

const StyledInput = styled.input.attrs({
  border: "default",
  borderRadius: "default",
  height: "input",
})`
  &:focus {
    outline: none;
    box-shadow: ${props => props.theme.shadows.focus};
  }
  ${border} ${color} ${layout} ${space}
`
const StyledTextarea = styled.textarea.attrs({
  border: "default",
  borderRadius: "default",
  width: "100%",
  p: "12px",
})`
  &:focus {
    outline: none;
    box-shadow: ${props => props.theme.shadows.focus};
  }
  ${border} ${color} ${layout} ${space}
`

const StyledTr = styled.tr.attrs({
  background: "white",
  borderBottomWidth: "1px",
  borderBottomStyle: "solid",
  borderBottomColor: "table",
  height: "table-row",
})`
  &:hover {
    background: ${props => props.theme.colors.hover};
  }
  ${border} ${color} ${layout}
`
const iconFloatingStyles = {
  position: "absolute",
  right: "-75%",
  top: "-75%",
  background: "#fff",
}

export {
  StyledButton,
  StyledButtonSecondary,
  StyledLabel,
  StyledInput,
  StyledTextarea,
  StyledTr,
  iconFloatingStyles,
}
